import axios from "../axios";

class FileDisplayer {
  async downloadFile(url, filetype = "application/pdf") {
    const { data } = await axios({
      method: "GET",
      url: url,
      responseType: 'blob',
      timeout: 60000,
      headers: { "Content-Type": filetype }
    });
    return data;
  }

  displayPdf(blob, title = "", icon) {
    const url = URL.createObjectURL(blob);
    const win = window.open(url, "_blank");
    
    if (win) {
      win.document.title = title;
      
      // Optional: Add icon if needed
      if (icon) {
        const link = win.document.createElement('link');
        link.rel = 'icon';
        link.href = icon;
        win.document.head.appendChild(link);
      }
      
      // Clean up the object URL when the window is closed
      win.addEventListener('beforeunload', () => {
        URL.revokeObjectURL(url);
      });
    }
  }

  convertBlobToPdf = (blob, filename, filetype = "application/pdf") => {
    const file = new File([blob], `${filename}.pdf`, { type: filetype });
    return file;
  }

  // Convenience method to download and display in one call
  async downloadAndDisplayPdf(url, title = "", icon, filetype = "application/pdf") {
    const blob = await this.downloadFile(url, filetype);
    this.displayPdf(blob, title, icon);
  }
}

// export default new FileDisplayer(); // Export singleton instance
export default FileDisplayer;